<template>
  <div id="login">
    <div class="center">
      <div class="content">
        <el-form :model="ReginForm" ref="ReginForm" :rules="rule" class="regform" label-width="0">
          <div class="login-text">
            <span class="font-28 fontcolor">修改密码</span>
          </div>
          <el-form-item prop="userName">
            <!-- <el-col :span="24"> <span class="span_red">仅支持中国大陆地区手机号码。</span> </el-col> -->

            <el-input
              name="userName131"
              id="enterName3"
              class="input-backgroud"
              autocomplete="off"
              placeholder="用户名"
              v-model="ReginForm.userName"
              :maxlength="20"
            ></el-input>
          </el-form-item>

          <el-form-item prop="yuanPassword">
            <el-input
              :maxlength="20"
              :type="ReginForm.show.check?'text':'password'"
              v-model="ReginForm.yuanPassword"
              placeholder="原密码"
            >
              <img
                :src="ReginForm.show.check?src1:src2"
                slot="suffix"
                alt
                style="margin: 10px 0; width:20px;"
                @click="ReginForm.show.check=!ReginForm.show.check"
              />
            </el-input>
          </el-form-item>

          <el-form-item prop="currentPassword">
            <el-input
              :maxlength="20"
              :type="ReginForm.show.old?'text':'password'"
              v-model="ReginForm.currentPassword"
              placeholder="请设置您的密码"
            >
              <img
                :src="ReginForm.show.old?src1:src2"
                slot="suffix"
                alt
                style="margin: 10px 0; width:20px;"
                @click="ReginForm.show.old=!ReginForm.show.old"
              />
            </el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input
              :maxlength="20"
              :type="ReginForm.show.new?'text':'password'"
              v-model="ReginForm.checkPass"
              placeholder="请再次输入密码"
            >
              <img
                :src="ReginForm.show.new?src1:src2"
                slot="suffix"
                alt
                style="margin: 10px 0; width:20px;"
                @click="ReginForm.show.new=!ReginForm.show.new"
              />
            </el-input>
          </el-form-item>

          <el-form-item class="pastop" prop="imgCode">
            <el-col :span="12" class="col1">
              <el-input
                name="userName1121"
                id="enterName222"
                autocomplete="off"
                v-model="ReginForm.imgCode"
                placeholder="请输入验证码"
              />
            </el-col>
            <el-col :span="12" class="col1">
              <img
                id="verifyCode11"
                width="100%"
                height="32px"
                :src="'data:image/jpeg;base64,'+verifyCode"
                v-on:click="GetImgCode"
              />
            </el-col>
          </el-form-item>

          <el-form-item style="text-align:center;">
            <el-button
              type="primary"
              class="submitBtn"
              @click.native.prevent="submit"
              :loading="logining"
            >确定</el-button>
            <el-form-item>
              <!-- <el-col :span="5" style="text-align:left;">了解更多</el-col> -->

              <el-col :span="18" class="font-14 fontcolor" style="text-align:right;">返回,</el-col>
              <el-col :span="6">
                <a href="javascript:void(0);" @click="handleRegisterBtn">登录</a>
              </el-col>
            </el-form-item>
            <!-- <hr> -->
            <!-- <p>已经有账号，马上去<span class="to" @click="tologin">登录</span></p> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapMutations } from "vuex";

import { GetSendSMS, updateregister } from "@/api/user/userInfo";
import { GetVerifyCode } from "@/api/user/userInfo";

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ReginForm.checkPass !== "") {
          this.$refs.ReginForm.validateField("checkPass");
        }
        callback();
      }
    };

    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ReginForm.currentPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      verifyCode: "",
      checkRecord: false,
      ReginForm: {
        checkPass: "",
        currentPassword: "",
        show: {
          old: false,
          new: false,
          check: false
        },
        userName: "",
        yuanPassword: "",
        imgId: 0,
        imgCode: ""
      },
      logining: false,
      sendAuthCode: true,
      /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */
      auth_time: 0,
      /*倒计时 计数器*/

      rule: {
        checkPass: [
          {
            validator: validatePass2,
            trigger: "blur"
          }
        ],
        currentPassword: [
          {
            validator: validatePass,
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z0-9]{4,16}$/,
            message: "密码由字母(大小写)、数字组成，长度4-16位",
            trigger: "blur"
          }
        ],
        yuanPassword: [
          {
            required: true,
            message: "请输入原密码！",
            trigger: "blur"
          }
        ],
        userName: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: "blur"
          }
        ],

        imgCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ]
      }
    };
  },

  methods: {
    ...mapMutations(["Login", "Setoutflag"]),

    GetImgCode() {
      GetVerifyCode().then(res => {
        // //console.log(res)
        this.verifyCode = res.data.verityImg;
        this.ReginForm.imgId = res.data.imgId;
      });
    },
    //  验证
    getAuthCode: function() {
      let verification = this.ReginForm.phone;

      if (verification.trim() == "") {
        this.$message.error("请输入手机号");
        return;
      }
      GetSendSMS(verification).then(res => {
        if (res.status === 0) {
        }
        if (res.status === 1) {
          this.$message.error("手机号已被注册过");
        }
        if (res.status === -5001) {
          this.$message.error("短信发送失败");
        }
      });

      this.sendAuthCode = false;
      //设置倒计时秒
      this.auth_time = 60;
      this.auth_timetimer = setInterval(() => {
        this.auth_time--;
        if (this.auth_time <= 0) {
          this.sendAuthCode = true;
          clearInterval(this.auth_timetimer);
        }
      }, 1000);
    },

    changeClick() {
      this.checkRecord = !this.checkRecord;
      //console.log(this.checkRecord)
    },
    // ...
    submit() {
      this.$refs.ReginForm.validate(valid => {
        if (valid) {
          this.logining = true;

          let newuserinfo = {
            userName: this.ReginForm.userName,
            ypassword: this.ReginForm.yuanPassword,
            password: this.ReginForm.checkPass,
            imgId: this.ReginForm.imgId,
            imgCode: this.ReginForm.imgCode
          };

          updateregister(newuserinfo)
            .then(res => {
              if (res.status === 0) {
                this.$router.push("/Login");
                this.logining = false;
                // this.Setoutflag(true)
                // this.Login(res.data)
                // this.$router.push("/index")
              }
              if (res.status === -5002) {
                this.$message.error("修改失败!");
                this.logining = false;
              }
            })
            .catch(err => {
              this.logining = false;
            });

          //console.log("开始写入后台数据！");
        } else {
          this.logining = false;
          //console.log("submit err");
        }
      });
    },

    handleRegisterBtn() {
      this.$router.push("/Login");
    }
  },
  mounted: function() {
    // this.sendAuthCode = true;
    this.GetImgCode();
    // clearInterval(this.auth_timetimer);
  },
  destroyed() {
    // alert("銷毀")
    // this.onClose()
  }
};
</script>
<style scoped >
.title{
  font-size: 24px;
}
.title1{
  text-align: center;
}
.pastop {
margin-top: 25px;
width: 140%;
}
.submitBtn{
margin-top: 15%;
}
.col2 {
text-align: center;
}


.to {
color: #115599a0;
cursor: pointer;
}


.login-text {
text-align: center;
margin-top: 1px;
margin-bottom: 40px;
}

#login {
width: 100%;
height: 100%;
background-color: #376c95b7;
background-size: cover;
position: absolute;
}
.center {
width: 100%;
}
  .loginbox img {
    width: 31%;
    height: 7%;
    top: calc(23%);
    left: calc(32%);
    position: absolute;
  }
  .content {
    width: 30%;
    height: 50%;
    top: calc(25%);
    left: calc(33%);
    background-color:#376c95b7;
    background-size: cover;
    position: absolute;
    padding: 10px 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
    .content_tip {
      text-align: right;
      font-size: 14px;
      color: #37acfe;
      height: 14px;
      margin-top: 20px;
      margin-bottom: 20px;
      cursor: pointer;
    }


  .center {
    width: 1500px;
  }


.bottom {
  height: 50px;
  width: 100%;
  position: absolute;
  bottom: 0;
  text-align: center;
  font-size: 12px;
  line-height: 50px;
  color: #131997;
}


.span_red {
color: rgb(255, 0, 0);
}

.col1 {
width: 80%;
display: flex;
align-items: center;
text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/forgetpassword.vue